<template>
  <div>
    <input
      v-model="input"
      class="keyboard-input"
      readonly
      placeholder="Toca los números"
    />
    <div ref="keyboard" class="my-keyboard"></div>
  </div>
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
  name: "NumericKeyboard",
  data() {
    return {
      input: "",
      keyboard: null
    };
  },
  mounted() {
    this.keyboard = new Keyboard(this.$refs.keyboard, {
      layout: {
        default: [
          "1 2 3",
          "4 5 6",
          "7 8 9",
          "0 {bksp}"
        ]
      },
      display: {
        "{bksp}": "⌫"
      },
      theme: "hg-theme-default my-custom-theme", // Puedes agregar tus propias clases
      onChange: input => {
        this.input = input;
      },
      onKeyPress: button => {
        // Aquí puedes manejar eventos especiales si lo deseas
        console.log(button)
      }
    });
  },
  watch: {
    input(val) {
      if (this.keyboard) {
        this.keyboard.setInput(val);
      }
    }
  }
};
</script>

<style scoped>
/* Personalización de los botones y el fondo */
.my-keyboard {
  max-width: 300px;
  margin: 20px auto 0;
}

.my-custom-theme .hg-button {
  background: #1976d2;
  color: #fff;
  border-radius: 8px;
  margin: 4px;
  font-size: 1.3rem;
  transition: background 0.2s;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.08);
}

.my-custom-theme .hg-button:hover,
.my-custom-theme .hg-button:active {
  background: #1565c0;
}

.keyboard-input {
  width: 100%;
  max-width: 300px;
  font-size: 1.4rem;
  padding: 10px;
  margin-bottom: 12px;
  text-align: right;
  border-radius: 6px;
  border: 1px solid #bbb;
}
</style>